
import Vue from 'vue';
import { Button, Icon } from '@descomplica/vue-components';
import CertificateInformationalCard from '@/components/cards/postgrad/CertificateInformationalCard.vue';
import { CourseModel } from '@descomplica/dex-models';
import { CourseCertificateModel } from '@/models/studentDocuments';
import { downloadImageFromUrl, downloadPdfFromUrl } from '@/helpers/download';
import Analytics from '@/helpers/analytics';
import { EVENT_LABELS } from '@/helpers/analytics/labels';
import { isMobileDevice } from '@/helpers/mobile';
import {
  TrackCertificateDefaultParams,
  TrackCertificateDownloadButtonClick,
} from '@/helpers/analytics/types';
import { PostgradEarlyGraduationTrackingInformation } from '@/models/postgradEarlyGraduation/PostgradEarlyGraduationModel';
import { ChimeraCourseModel } from '@/models/chimera/ChimeraCourseModel';

export default Vue.extend({
  components: { CertificateInformationalCard, Button, Icon },
  props: {
    loadError: {
      type: Boolean,
      default: false,
    },
    defaultTrackingParams: {
      type: Object as Vue.PropType<TrackCertificateDefaultParams>,
      required: true,
    },
  },
  computed: {
    currentCourse(): CourseModel {
      return this.$store.getters.currentCourse;
    },
    currentChimeraCourse(): ChimeraCourseModel {
      return this.$store.getters.getCurrentChimeraCourse;
    },
    certificateByCourseId(): CourseCertificateModel {
      return this.$store.getters.certificateByCourseId(this.currentCourse.id);
    },
    isMobileDevice(): boolean {
      return isMobileDevice();
    },
    certificatePreviewSource(): string {
      return this.certificateByCourseId.socialVersionImageUrl;
    },
    earlyGraduationTrackingProps(): PostgradEarlyGraduationTrackingInformation {
      return this.$store.getters.earlyGraduationTrackings(this.currentChimeraCourse);
    },
  },
  methods: {
    async downloadFiles(): Promise<void> {
      if (!this.certificateByCourseId) return;
      try {
        await Promise.all([
          ...this.certificateByCourseId.originalVersionImageUrls.map((url: string) =>
            downloadImageFromUrl({
              imageUrl: url,
              fileName: `Certificado de Conclusão - ${this.currentCourse.name}`,
            }),
          ),
          downloadPdfFromUrl({
            pdfUrl: this.certificateByCourseId.originalVersionPdfUrl,
            fileName: `Certificado de Conclusão - ${this.currentCourse.name}`,
          }),
        ]);
        Analytics.trackEvent<TrackCertificateDownloadButtonClick>(
          EVENT_LABELS.postgradStudentDocumentsCertificateDownload,
          {
            ...this.defaultTrackingParams,
            file_type: 'official',
            is_certificate_sharing_result_step: false,
            ...this.earlyGraduationTrackingProps,
          },
        );
      } catch (err) {
        Analytics.trackEvent<TrackCertificateDownloadButtonClick>(
          EVENT_LABELS.postgradStudentCertificateDownloadError,
          {
            ...this.defaultTrackingParams,
            file_type: 'official',
            is_certificate_sharing_result_step: false,
          },
        );
      }
    },
    shareCertificate(): void {
      this.$emit('onShareButtonClick');
    },
    reloadPage() {
      Analytics.trackEvent(EVENT_LABELS.buttonClicked, {
        ...this.defaultTrackingParams,
        reload_certificate_page: true,
      });
      window.location.reload();
    },
  },
});
